import React, { useEffect, useState } from "react";
import {
  Grid,
  GridItem,
  Heading,
  FormLabel,
  Input,
  Text,
  InputLeftElement,
  InputGroup,
  Checkbox,
  Select,
  RadioGroup,
  Radio,
  HStack,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Box,
  Textarea,
} from "@chakra-ui/react"; // Assuming you are using Chakra UI
import { HSeparator } from "common/components/separator/Separator";
import { EmailIcon, PhoneIcon, StarIcon } from "@chakra-ui/icons";
import { globalStyles } from "common/theme/styles";
import { constant } from "common/constant";
import { crmConstant } from "services/Crm/constant";
import { getApi } from "common/services/api";
import ReactSelect from "react-select";
import { useDispatch } from "react-redux";
import { getContactList } from "common/redux/reducers/contactLeadSlice";
import { useSelector } from "react-redux";

const CustomForm = ({
  moduleData,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
  viewMode = false,
  setDealRelatedFields = () => void 0,
}) => {
  function valueChangeHandler(e, field) {
    let value = e.target.value;
    if (field.type === "tel") {
      // Allow the "+" sign only as the first character
      if (value.startsWith("+")) {
        value = "+" + value.replace(/[^0-9]/g, ""); // Keep + at the start, remove all non-numeric characters
      } else {
        value = value.replace(/[^\d]/g, ""); // Remove all non-numeric characters
      }
      // Limit the value to 13 characters or fewer (including the + sign)
      if (value.length > 16) {
        // We allow + at the start, so the length limit is 14
        value = value.slice(0, 16); // Truncate if it exceeds 14 characters (1 for + and 13 for digits)
      }

      handleChange({
        target: { name: e.target.name, value },
      }); // Update form state
    } else {
      handleChange(e);
    }
  }
  const dispatch = useDispatch();
  const [availableContacts, setAvailableContacts] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [data, setData] = useState([]);
  const contactList = useSelector((state) => state.contactLead.contacts);
  const fetchDynamicData = async (id, type) => {
    try {
      const result = await getApi(
        user.role === "superAdmin"
          ? `api/form?moduleId=${id}&allData=true`
          : `api/form?moduleId=${id}&createBy=${user._id}`
      );

      if (result.status === 200 && type.toLowerCase() === "account") {
        const transformed = result.data?.data?.map((item) => ({
          value: item?._id ?? "",
          label: item?.accountName ?? "",
          contacts: item?.contact ?? [],
        }));

        setData(transformed ?? []);
      }
    } catch (error) {
      console.error("Error fetching deals:", error);
    }
  };

  const fetchCustomDataFields = async (type) => {
    try {
      const result = await getApi(`api/custom-field/?moduleName=${type}`);
      const singaleData = result?.data?.find(
        (item) => item?.moduleName === type
      );
      if (singaleData?._id) {
        fetchDynamicData(singaleData._id, "account");
      }
    } catch (error) {
      console.error("Error fetching custom field:", error);
    }
  };

  const handleTextareaChange = (e, field, valueChangeHandler) => {
    const input = e.target.value;
    const limitedText = input.slice(0, 1000);
    valueChangeHandler(
      {
        ...e,
        target: {
          ...e.target,
          value: limitedText,
          name: field.name,
        },
      },
      field
    );
  };

  const getContactListData = async () => {
    dispatch(getContactList, { fetchAllData: true });
  };
  const [relatedContacts, setRelatedContacts] = useState([]);

  useEffect(() => {
    if (moduleData?.moduleName === constant.deals) {
      fetchCustomDataFields("Accounts");
      getContactListData();
    }
  }, [moduleData?.fields]);
  useEffect(() => {
    if (contactList.length > 0) {
      const formattedContacts = contactList.map((contact) => ({
        value: contact._id,
        label: contact.contactName || "-",
      }));
      setAvailableContacts(formattedContacts);
    }
  }, [contactList]);
  const handleAccountChange = (e) => {
    const selectedValue = e.target.value;
    setFieldValue("account", selectedValue);

    const selectedItem = data.find((item) => item.value === selectedValue);
    const contactIds = [...new Set(selectedItem?.contacts || [])];

    const matchedContacts = contactList
      .filter((contact) => contactIds.includes(contact._id))
      .map((contact) => ({
        value: contact._id,
        label: contact.contactName || "-",
      }));

    setDealRelatedFields((prev) => ({
      ...prev,
      account: selectedValue,
    }));
    setAvailableContacts(matchedContacts || []);
  };

  const colors = globalStyles.colors;

  return (
    <Grid templateColumns="repeat(12, 1fr)" gap={3}>
      {moduleData?.headings?.length > 0 ? (
        <>
          {moduleData?.headings?.map((item, ind) => (
            <>
              <GridItem colSpan={{ base: 12 }}>
                {ind !== 0 && <HSeparator />}
                <Heading as="h1" size="md" mt="10px">
                  {ind + 1}. {item?.heading}
                </Heading>
              </GridItem>
              {moduleData?.fields
                ?.filter((itm) => itm?.belongsTo === item?._id)
                ?.filter((field) => field.name !== "assignmentToName")
                ?.map((field) => {
                  console.log(field.type, "field.type");

                  return (
                    <GridItem
                      colSpan={{
                        base: field.type === "textArea" ? 12 : 12,
                        sm: field.type === "textArea" ? 12 : 6,
                      }}
                    >
                      {field.type === "check" ? (
                        ""
                      ) : (
                        <FormLabel
                          display="flex"
                          ms="4px"
                          fontSize="sm"
                          fontWeight="500"
                          mb="8px"
                          htmlFor={field.name}
                        >
                          {field.label}{" "}
                          {field.validation &&
                            field.validation.find(
                              (validation) => validation.require
                            ) && <span style={{ color: "red" }}>*</span>}
                        </FormLabel>
                      )}
                      {field.type === "textArea" ? (
                        <Textarea
                          disabled={viewMode}
                          resize={"none"}
                          fontSize="sm"
                          id={field.name}
                          name={field.name}
                          onChange={(e) => {
                            valueChangeHandler(e, field);
                          }}
                          onBlur={handleBlur}
                          value={values[field.name]}
                          fontWeight="500"
                          placeholder={`Enter ${field.label}`}
                          borderColor={
                            errors?.[field?.name] && touched?.[field?.name]
                              ? colors.error["100"]
                              : null
                          }
                        />
                      ) : field.type === "range" ? (
                        <>
                          {values.leadRating || 0}
                          <Slider
                            disabled={viewMode}
                            ml={2}
                            aria-label="slider-ex-1"
                            colorScheme="yellow"
                            value={values.leadRating}
                            min={field?.validation[1]?.value}
                            max={field?.validation[2]?.value}
                            step={0.1}
                            defaultValue={0}
                            onChange={(value) =>
                              setFieldValue(field.name, value)
                            }
                          >
                            <SliderTrack>
                              <SliderFilledTrack />
                            </SliderTrack>
                            <SliderThumb boxSize={6}>
                              <Box color="yellow.300" as={StarIcon} />
                            </SliderThumb>
                          </Slider>
                        </>
                      ) : field.type === "radio" ? (
                        <RadioGroup
                          disabled={viewMode}
                          name={field.name}
                          value={values[field.name]}
                          onChange={(value) => setFieldValue(field.name, value)}
                        >
                          <HStack spacing="24px">
                            {field.options.map((option) => (
                              <Radio key={option._id} value={option.value}>
                                {option.name}
                              </Radio>
                            ))}
                          </HStack>
                        </RadioGroup>
                      ) : field.type === "select" ? (
                        <Select
                          disabled={viewMode}
                          fontSize="sm"
                          id={field.name}
                          name={field.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values[field.name]}
                          fontWeight="500"
                          borderColor={
                            errors?.[field?.name] && touched?.[field?.name]
                              ? "red.300"
                              : null
                          }
                        >
                          {field.options.map((option) => (
                            <option key={option._id} value={option.value}>
                              {option.name}
                            </option>
                          ))}
                        </Select>
                      ) : field.type === "check" ? (
                        <Checkbox
                          disabled={viewMode}
                          isChecked={values[field.name]}
                          onChange={() =>
                            setFieldValue(field.name, !values[field.name])
                          }
                        >
                          {field.label}
                        </Checkbox>
                      ) : (
                        <>
                          <InputGroup>
                            {field.type === "tel" ? (
                              <InputLeftElement
                                pointerEvents="none"
                                children={
                                  <PhoneIcon
                                    color="gray.300"
                                    borderRadius="16px"
                                  />
                                }
                              />
                            ) : (
                              field.type === "email" && (
                                <InputLeftElement
                                  pointerEvents="none"
                                  children={
                                    <EmailIcon
                                      color="gray.300"
                                      borderRadius="16px"
                                    />
                                  }
                                />
                              )
                            )}
                            <Input
                              disabled={viewMode}
                              fontSize="sm"
                              type={field.type}
                              id={field.name}
                              name={field.name}
                              onChange={(e) => {
                                valueChangeHandler(e, field);
                              }}
                              onBlur={handleBlur}
                              value={values[field.name]}
                              fontWeight="500"
                              placeholder={`Enter ${field.label}`}
                              borderColor={
                                errors?.[field?.name] && touched?.[field?.name]
                                  ? "red.300"
                                  : null
                              }
                            />
                          </InputGroup>
                        </>
                      )}
                      {touched[field?.name] && errors?.[field?.name] ? (
                        <Text
                          mb="10px"
                          color={"red"}
                          fontSize="sm"
                          textTransform={"capitalize"}
                        >
                          {" "}
                          {errors?.[field?.name]}
                        </Text>
                      ) : null}
                    </GridItem>
                  );
                })}
            </>
          ))}
          <>
            {moduleData?.fields
              ?.filter((itm) => !itm?.belongsTo)
              ?.filter((field) => field.name !== "assignmentToName")
              ?.map((field) => {
                return (
                  <GridItem
                    colSpan={{
                      base: field.type === "textArea" ? 12 : 12,
                      sm: field.type === "textArea" ? 12 : 6,
                    }}
                  >
                    {field.type === "check" ? (
                      ""
                    ) : (
                      <FormLabel
                        display="flex"
                        ms="4px"
                        fontSize="sm"
                        fontWeight="500"
                        mb="8px"
                        htmlFor={field.name}
                      >
                        {field.label}{" "}
                        {field.validation &&
                          field.validation.find(
                            (validation) => validation.require
                          ) && <span style={{ color: "red" }}>*</span>}
                      </FormLabel>
                    )}
                    {field.type === "textArea" ? (
                      <Textarea
                        disabled={viewMode}
                        resize={"none"}
                        fontSize="sm"
                        id={field.name}
                        name={field.name}
                        onChange={(e) => {
                          valueChangeHandler(e, field);
                        }}
                        onBlur={handleBlur}
                        value={values[field.name]}
                        fontWeight="500"
                        placeholder={`Enter ${field.label}`}
                        borderColor={
                          errors?.[field?.name] && touched?.[field?.name]
                            ? colors.error["100"]
                            : null
                        }
                      />
                    ) : field.type === "range" ? (
                      <>
                        {values.leadRating || 0}
                        <Slider
                          disabled={viewMode}
                          ml={2}
                          aria-label="slider-ex-1"
                          colorScheme="yellow"
                          min={field?.validation[1]?.value}
                          max={field?.validation[2]?.value}
                          step={0.1}
                          defaultValue={0}
                          onChange={(value) => setFieldValue(field.name, value)}
                        >
                          <SliderTrack>
                            <SliderFilledTrack />
                          </SliderTrack>
                          <SliderThumb boxSize={6}>
                            <Box color="yellow.300" as={StarIcon} />
                          </SliderThumb>
                        </Slider>
                      </>
                    ) : field.type === "radio" ? (
                      <RadioGroup
                        disabled={viewMode}
                        name={field.name}
                        value={values[field.name]}
                        onChange={(value) => setFieldValue(field.name, value)}
                      >
                        <HStack spacing="24px">
                          {field.options.map((option) => (
                            <Radio key={option._id} value={option.value}>
                              {option.name}
                            </Radio>
                          ))}
                        </HStack>
                      </RadioGroup>
                    ) : field.type === "select" ? (
                      <Select
                        disabled={viewMode}
                        fontSize="sm"
                        id={field.name}
                        name={field.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values[field.name]}
                        fontWeight="500"
                        borderColor={
                          errors?.[field?.name] && touched?.[field?.name]
                            ? "red.300"
                            : null
                        }
                      >
                        <option value="">Select {field.label}</option>
                        {field.options.map((option) => (
                          <option key={option._id} value={option.value}>
                            {option.name}
                          </option>
                        ))}
                      </Select>
                    ) : field.type === "check" ? (
                      <Checkbox
                        disabled={viewMode}
                        isChecked={values[field.name]}
                        onChange={() =>
                          setFieldValue(field.name, !values[field.name])
                        }
                      >
                        {field.label}
                      </Checkbox>
                    ) : (
                      <>
                        <InputGroup>
                          {field.type === "tel" && (
                            <InputLeftElement
                              pointerEvents="none"
                              children={
                                <PhoneIcon
                                  color="gray.300"
                                  borderRadius="16px"
                                />
                              }
                            />
                          )}
                          <Input
                            disabled={viewMode}
                            fontSize="sm"
                            type={field.type}
                            id={field.name}
                            onBlur={handleBlur}
                            value={values[field.name]}
                            onChange={(e) => {
                              valueChangeHandler(e, field);
                            }}
                            fontWeight="500"
                            placeholder={`Enter ${field.label}`}
                            borderColor={
                              errors?.[field?.name] && touched?.[field?.name]
                                ? "red.300"
                                : null
                            }
                          />
                        </InputGroup>
                      </>
                    )}
                    {touched[field?.name] && errors?.[field?.name] ? (
                      <Text mb="10px" fontSize="sm" color={"red"}>
                        {" "}
                        {errors?.[field?.name]}
                      </Text>
                    ) : null}
                  </GridItem>
                );
              })}
          </>
        </>
      ) : (
        <>
          {moduleData?.fields
            ?.filter((itm) => !itm?.belongsTo)
            ?.filter(
              (field) =>
                field.name !== "assignmentToName" && field.type !== "textArea"
            )
            ?.map((field) => (
              <GridItem
                colSpan={{
                  base: field.type === "textArea" ? 12 : 12,
                  sm: field.type === "textArea" ? 12 : 6,
                }}
              >
                {field.type === "check" ? (
                  ""
                ) : (
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    mb="8px"
                    htmlFor={field.name}
                  >
                    {field.label}{" "}
                    {field.validation &&
                      field.validation.find(
                        (validation) => validation.require
                      ) && <span style={{ color: "red" }}>*</span>}
                  </FormLabel>
                )}
                {field.type === "textArea" ? (
                  <Textarea
                    disabled={viewMode}
                    resize={"none"}
                    fontSize="sm"
                    id={field.name}
                    name={field.name}
                    onChange={(e) => {
                      valueChangeHandler(e, field);
                    }}
                    onBlur={handleBlur}
                    value={values[field.name]}
                    fontWeight="500"
                    placeholder={`Enter ${field.label}`}
                    borderColor={
                      errors?.[field?.name] && touched?.[field?.name]
                        ? colors.error["100"]
                        : null
                    }
                  />
                ) : field.type === "range" ? (
                  <>
                    {values.leadRating || 0}
                    <Slider
                      disabled={viewMode}
                      ml={2}
                      aria-label="slider-ex-1"
                      colorScheme="yellow"
                      min={field?.validation[1]?.value}
                      max={field?.validation[2]?.value}
                      step={0.1}
                      defaultValue={0}
                      onChange={(value) => setFieldValue(field.name, value)}
                    >
                      <SliderTrack>
                        <SliderFilledTrack />
                      </SliderTrack>
                      <SliderThumb boxSize={6}>
                        <Box color="yellow.300" as={StarIcon} />
                      </SliderThumb>
                    </Slider>
                  </>
                ) : field.type === "radio" ? (
                  <RadioGroup
                    disabled={viewMode}
                    name={field.name}
                    value={values[field.name]}
                    onChange={(value) => setFieldValue(field.name, value)}
                  >
                    <HStack spacing="24px">
                      {field.options.map((option) => (
                        <Radio
                          disabled={viewMode}
                          key={option._id}
                          value={option.value}
                        >
                          {option.name}
                        </Radio>
                      ))}
                    </HStack>
                  </RadioGroup>
                ) : field.type === "select" ? (
                  <Select
                    disabled={viewMode}
                    fontSize="sm"
                    id={field.name}
                    name={field.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values[field.name]}
                    fontWeight="500"
                    borderColor={
                      errors?.[field?.name] && touched?.[field?.name]
                        ? "red.300"
                        : null
                    }
                  >
                    <option value="">Select {field.label}</option>
                    {field.options.map((option) => (
                      <option key={option._id} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                ) : field.type === "check" ? (
                  <Checkbox
                    disabled={viewMode}
                    isChecked={values[field.name]}
                    onChange={() =>
                      setFieldValue(field.name, !values[field.name])
                    }
                  >
                    {field.label}
                  </Checkbox>
                ) : (
                  <>
                    <InputGroup>
                      {field.type === "tel" && (
                        <InputLeftElement
                          pointerEvents="none"
                          children={
                            <PhoneIcon color="gray.300" borderRadius="16px" />
                          }
                        />
                      )}
                      <Input
                        disabled={viewMode}
                        fontSize="sm"
                        type={field.type}
                        id={field.name}
                        name={field.name}
                        onChange={(e) => {
                          valueChangeHandler(e, field);
                        }}
                        onBlur={handleBlur}
                        value={values[field.name]}
                        fontWeight="500"
                        placeholder={`Enter ${field.label}`}
                        borderColor={
                          errors?.[field?.name] && touched?.[field?.name]
                            ? "red.300"
                            : null
                        }
                      />
                    </InputGroup>
                  </>
                )}
                {touched[field?.name] && errors?.[field?.name] ? (
                  <Text mb="10px" fontSize="sm" color={"red"}>
                    {" "}
                    {errors?.[field?.name]}
                  </Text>
                ) : null}
              </GridItem>
            ))}
          {moduleData?.moduleName === constant.deals && (
            <>
              <GridItem colSpan={{ base: 6 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                >
                  {constant.selctAccounts} <Text color="red">*</Text>
                </FormLabel>

                <Select
                  disabled={viewMode}
                  placeholder={crmConstant.assignTo}
                  name="account"
                  value={values.account}
                  onChange={handleAccountChange}
                >
                  {(data || []).map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Select>

                <Text mb="10px" color="red" fontSize="sm">
                  {errors.account && errors.account}
                </Text>
              </GridItem>

              {availableContacts.length > 0 && values.account && (
                <GridItem colSpan={{ base: 6 }}>
                  <FormLabel fontSize="sm" fontWeight="500" mb="8px">
                    {constant.selectContacts} {values.related}
                  </FormLabel>

                  <ReactSelect
                    isMulti
                    isDisabled={viewMode}
                    name="contact"
                    value={availableContacts.filter((option) =>
                      values.contact?.includes(option.value)
                    )}
                    options={availableContacts}
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions.map(
                        (opt) => opt.value
                      );
                      setFieldValue("contact", selectedValues);
                      setDealRelatedFields((prev) => ({
                        ...prev,
                        contact: selectedValues,
                      }));
                    }}
                  />

                  <Text mb="10px" color="red" fontSize="sm">
                    {errors.contact && touched.contact && errors.contact}
                  </Text>
                </GridItem>
              )}
            </>
          )}

          {moduleData?.fields
            ?.filter((itm) => !itm?.belongsTo)
            ?.filter(
              (field) =>
                field.name !== "assignmentToName" && field.type === "textArea"
            )
            ?.map((field) => (
              <GridItem key={field._id} colSpan={{ base: 12 }}>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                  htmlFor={field.name}
                >
                  {field.label}{" "}
                  {field.validation &&
                    field.validation.find(
                      (validation) => validation.require
                    ) && <span style={{ color: "red" }}>*</span>}
                </FormLabel>
                <Textarea
                  disabled={viewMode}
                  resize={"none"}
                  fontSize="sm"
                  id={field.name}
                  name={field.name}
                  onChange={(e) =>
                    handleTextareaChange(e, field, valueChangeHandler)
                  }
                  onBlur={handleBlur}
                  value={values[field.name]}
                  fontWeight="500"
                  placeholder={`Enter ${field.label}`}
                  borderColor={
                    errors?.[field?.name] && touched?.[field?.name]
                      ? colors.error["100"]
                      : null
                  }
                />
                <Text
                  mt={1}
                  fontSize="xs"
                  textAlign="right"
                  color={
                    (values[field.name]?.length || 0) === 1000
                      ? "red.500"
                      : "gray.500"
                  }
                >
                  {0 + (values[field.name]?.length || 0)}/1000
                </Text>
                {touched[field?.name] && errors?.[field?.name] ? (
                  <Text mb="10px" fontSize="sm" color={"red"}>
                    {errors?.[field?.name]}
                  </Text>
                ) : null}
              </GridItem>
            ))}
        </>
      )}
    </Grid>
  );
};

export default CustomForm;
